import { render, staticRenderFns } from "./stu_LayoutHeader.vue?vue&type=template&id=07310828&scoped=true"
import script from "./stu_LayoutHeader.vue?vue&type=script&lang=js"
export * from "./stu_LayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./stu_LayoutHeader.vue?vue&type=style&index=0&id=07310828&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07310828",
  null
  
)

export default component.exports